module.exports = __webpack_public_path__ + "static/media/logos.fc6c9f0f.png";